// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1Lugd","inputWrap":"Table_inputWrap__30Fkc","col":"Table_col__1PEM5","bmiTooltip":"Table_bmiTooltip__36Mun"};